// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function Logo({ ...other }) {
  return (
    <Box
      component="img"
      alt="logo"
      src="/static/brand/new_logo.svg"
      height={85.38}
      width={125.16}
      {...other}
    />
  );
}
